import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import LoginPage from '~/pages/login';
// import HomePage from '~/pages/home';
import AuditoriumPage from '~/pages/auditorium';
// import TrainingPage from '~/pages/training';
import ResourcesPage from '~/pages/resources';
import ResourcesGalleryPage from '~/pages/resources/resources-gallery';
import PrivateRoute from './components/PrivateRoute';
import LogsPage from './pages/logs';

// TODO: keep in object and map instead?
const routes = () => (
  <Switch>
    <Route path='/login'>
      <LoginPage />
    </Route>
    {/* <PrivateRoute exact={true} path='/' component={HomePage} /> */}
    <PrivateRoute exact={true} path='/resources' component={ResourcesPage} />
    <PrivateRoute path='/resources/gallery' component={ResourcesGalleryPage} />
    <PrivateRoute path='/auditorium' component={AuditoriumPage} />
    <PrivateRoute path='/logs' component={LogsPage} />
    {/* <PrivateRoute path='/training' component={TrainingPage} /> */}
    <Route render={() => <Redirect to={{ pathname: '/resources' }} />} />
  </Switch>
)

export default routes;



// WEBPACK FOOTER //
// ./src/routes.tsx